import React, { HTMLAttributes } from 'react';
interface IconProps extends HTMLAttributes<SVGElement> {
	width?: number | string;
	height?: number | string;
}
export const NoDataChatSessions = ({
	width = 200,
	height = 200,
	...restProps
}: IconProps) => {
	return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fillRule="evenodd"
      strokeLinejoin="round"
      strokeMiterlimit="2"
      clipRule="evenodd"
      viewBox="0 0 2892 1884"
      {...restProps}
		width={width}
			height={height}
    >
      <g>
        <g>
          <path
            fill="url(#_Linear1)"
            d="M2884.29 1632.01c-315.91 108.437-797.698 177.767-1337.06 177.767-539.359 0-1021.15-69.33-1337.06-177.767 315.91-80.513 797.698-131.99 1337.06-131.99 539.359 0 1021.15 51.477 1337.06 131.99z"
          ></path>
          <path
            fill="url(#_Linear2)"
            d="M449.932 260.918c22.253-15.327 49.21-24.303 78.248-24.303 76.265 0 138.182 61.917 138.182 138.182H.291A240.48 240.48 0 010 362.968c0-130.542 105.984-236.526 236.526-236.526 94.007 0 175.278 54.961 213.406 134.476z"
          ></path>
          <path
            fill="url(#_Linear3)"
            d="M2493.2 260.668c-19.682-13.557-43.527-21.496-69.212-21.496-67.457 0-122.224 54.766-122.224 122.224h589.153c.171-3.466.257-6.955.257-10.463 0-115.467-93.744-209.212-209.212-209.212-83.151 0-155.037 48.615-188.762 118.947z"
          ></path>
          <path
            fill="url(#_Linear4)"
            d="M2593.44 992.991c-14.384-9.908-31.811-15.71-50.582-15.71-49.299 0-89.324 40.025-89.324 89.324h430.568c.125-2.533.188-5.082.188-7.646 0-84.386-68.511-152.897-152.897-152.897-60.769 0-113.306 35.528-137.953 86.929z"
          ></path>
        </g>
        <g fill="#bdc5cf">
          <ellipse
            cx="1507.09"
            cy="442.372"
            rx="542.963"
            ry="442.372"
          ></ellipse>
          <path d="M1670.5 752.986l382.299 93.165a31.235 31.235 0 0035.664-43.631l-133.294-283.637L1670.5 752.986z"></path>
        </g>
        <g fill="#d9dee4">
          <ellipse cx="1268.79" cy="518.393" rx="450.955" ry="367.41"></ellipse>
          <path d="M1133.08 776.372L826.313 851.13a31.235 31.235 0 01-35.664-43.631l106.001-225.56 236.43 194.433z"></path>
        </g>
        <circle cx="1050.78" cy="529.586" r="58.526" fill="#f4f4f4"></circle>
        <circle cx="1241.81" cy="529.586" r="58.526" fill="#f4f4f4"></circle>
        <circle cx="1432.84" cy="529.586" r="58.526" fill="#f4f4f4"></circle>
        <g>
          <path
            fill="#f9b6b1"
            d="M2291.89 1769.86l-2.818 49.811 35.895.336v-52.919l-33.077 2.772zM2439.83 1842.79l2.819-49.811-35.896-.336v52.919l33.077-2.772z"
          ></path>
          <path
            fill="#eeedf2"
            d="M2452.51 1883.7l-57.461.114s-3.64-26.732 10.521-43.312h38.984s10.008 16.311 7.956 43.198z"
          ></path>
          <clipPath id="_clip5">
            <path d="M2452.51 1883.7l-57.461.114s-3.64-26.732 10.521-43.312h38.984s10.008 16.311 7.956 43.198z"></path>
          </clipPath>
          <g clipPath="url(#_clip5)">
            <path
              fill="#0c2139"
              d="M2392.5 1876.56H2454.477V1883.818H2392.5z"
            ></path>
          </g>
          <path
            fill="#eeedf2"
            d="M2253.94 1825.67s-31.088 12.833-36.384 27.066c-5.297 14.233 27.633 20.299 42.601 16.799s57.8-23.099 68.163-25.899c10.362-2.8 3.454-22.633-2.073-41.766 0 0-25.1 13.766-35.232.7-10.133-13.066-10.363 4.2-10.363 4.2l-26.712 18.9z"
          ></path>
          <clipPath id="_clip6">
            <path d="M2253.94 1825.67s-31.088 12.833-36.384 27.066c-5.297 14.233 27.633 20.299 42.601 16.799s57.8-23.099 68.163-25.899c10.362-2.8 3.454-22.633-2.073-41.766 0 0-25.1 13.766-35.232.7-10.133-13.066-10.363 4.2-10.363 4.2l-26.712 18.9z"></path>
          </clipPath>
          <g clipPath="url(#_clip6)">
            <path
              fill="#062249"
              d="M2219.38 1839.71s-3.065 10.871 6.013 16.486c9.079 5.614 31.598 7.287 44.332 1.672 12.733-5.615 48.34-18.517 48.34-18.517s14.266-5.376 17.096-10.393c2.829-5.018 5.777 24.848-8.489 29.866-14.266 5.017-78.052 15.889-78.052 15.889l-30.772-11.947s-9.55-10.752 1.532-23.056z"
            ></path>
          </g>
          <path
            fill="#062249"
            d="M2249.31 1204.4s3.835 474.919 28.541 581.311l53.569.093s7.115-109.747 1.581-189.853l15.869-201.274s20.644 138.22 35.621 184.566l7.286 225.991 61.932-.41s5.248-480.333-9.932-594.405c0 0-163.66 30.675-194.467-6.019z"
          ></path>
          <path
            fill="#f9b6b1"
            d="M2283.08 733.72s-9.42 84.187 25.008 105.342c0 0 7.051 4.62 6.881 12.775-.17 8.156 2.209 17.5 2.209 17.5l73.963-34.308-2.9-18.661s17.188-31.589 17.188-60.128c0-28.538-12.942-68.027-47.785-72.009-34.843-3.982-58.736 18.583-70.35 9.623-11.615-8.96-8.96-19.579-8.96-19.579s-35.307 36.592 4.746 59.445z"
          ></path>
          <clipPath id="_clip7">
            <path d="M2283.08 733.72s-9.42 84.187 25.008 105.342c0 0 7.051 4.62 6.881 12.775-.17 8.156 2.209 17.5 2.209 17.5l73.963-34.308-2.9-18.661s17.188-31.589 17.188-60.128c0-28.538-12.942-68.027-47.785-72.009-34.843-3.982-58.736 18.583-70.35 9.623-11.615-8.96-8.96-19.579-8.96-19.579s-35.307 36.592 4.746 59.445z"></path>
          </clipPath>
          <g clipPath="url(#_clip7)">
            <path
              fill="#f58586"
              d="M2374.4 797.461s-21.019 44.774-48.5 47.993c0 0 27.564 9.937 57.937-31.616 13.513-18.487 3.495-36.692 3.495-36.692l-12.932 20.315z"
            ></path>
            <path
              fill="#332e30"
              d="M2272.82 730.104s28.034 13.38 61.803-5.097c33.768-18.477 30.157 44.6 30.157 44.6s3.398-13.38 10.195-20.601c6.796-7.221 19.751 2.761 16.99 16.353-2.761 13.593-15.079 24.212-15.079 24.212l11.256 27.184s46.226 34.036 50.374-32.333c4.148-66.368-73.42-128.174-96.234-131.492-22.814-3.318-70.517-17.837-88.353 5.392-17.837 23.229-27.756 56.871 18.891 71.782z"
            ></path>
          </g>
          <path
            fill="#f9b6b1"
            d="M2062.96 997.012s-24.092-6.473-43.869-23.733-17.619-58.971-4.315-53.577c13.305 5.393 23.733 19.777 32.003 28.047s3.955-8.63-1.798-14.383c-5.753-5.753 13.305-6.832 19.058 7.191 5.753 14.024 48.544 39.195 48.544 39.195l-49.623 17.26zM2494.11 1242.49s-6.674 26.696-8.975 42.345c-2.302 15.649 1.381 29.917 6.213 38.662 4.833 8.745 35.441 3.222 40.964-4.143 5.523-7.364-1.841-60.985-10.586-76.403-8.745-15.419-27.616-.461-27.616-.461z"
          ></path>
          <path
            fill="#7f58ff"
            d="M2314.37 844.553l-16.99 24.919s-45.685 25.674-57.012 66.451c-11.327 40.776-27.562 95.145-27.562 95.145l-130.636-75.89-26.429 41.532s137.81 103.452 161.974 111.381c24.164 7.928 31.715-3.776 31.715-3.776l-2.266 125.728s127.994 18.878 199.73-9.439c0 0-3.775-63.43 2.643-93.258l35.108 120.087s26.29 2.127 44.655-.773c0 0-31.663-283.364-47.002-327.61-15.338-44.245-83.049-68.06-83.049-68.06l-8.549-24.304s-50.381 32.512-67.538 36.62c-17.156 4.108-5.758-14.85-8.792-18.753z"
          ></path>
        </g>
      </g>
      <defs>
        <linearGradient
          id="_Linear1"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(90 201.4 1437.67) scale(473.135)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#bdc5cf"></stop>
          <stop offset="1" stopColor="#bdc5cf" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear2"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="rotate(88.826 244.358 15.488) scale(604.0588)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#bdc5cf"></stop>
          <stop offset="1" stopColor="#bdc5cf" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear3"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="scale(-534.302 534.302) rotate(88.826 -2.33 -2.708)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#bdc5cf"></stop>
          <stop offset="1" stopColor="#bdc5cf" stopOpacity="0"></stop>
        </linearGradient>
        <linearGradient
          id="_Linear4"
          x1="0"
          x2="1"
          y1="0"
          y2="0"
          gradientTransform="matrix(-8.00038 390.4 390.4 8.00038 2719.56 676.205)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#bdc5cf"></stop>
          <stop offset="1" stopColor="#bdc5cf" stopOpacity="0"></stop>
        </linearGradient>
      </defs>
    </svg>
    		)};
